
export const isAbortError = (error: unknown): boolean => {
    const isAbortError =
	    (error && (error as any).name === "AbortError") ||
		(error instanceof DOMException && error.name === "AbortError")
    return isAbortError;
};